import { render, staticRenderFns } from "./StudentEvalControl.vue?vue&type=template&id=fa793516&scoped=true&lang=pug"
import script from "./StudentEvalControl.vue?vue&type=script&lang=js"
export * from "./StudentEvalControl.vue?vue&type=script&lang=js"
import style0 from "./StudentEvalControl.vue?vue&type=style&index=0&id=fa793516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa793516",
  null
  
)

export default component.exports